import { useEffect, useState } from 'react'

import { Stated } from '../BowtieManagment/BowtieViews'
import { ChartEvent } from '../types'

export function useBowtieStated(elementStated: Stated): ChartEvent {
    const [event, setEvent] = useState<ChartEvent>(elementStated?.event)

    useEffect(() => {
        if (elementStated) {
            const onEventUpdate = (): void => {
                setEvent(elementStated.event)
            }

            elementStated.listener.registerListener(onEventUpdate)

            return () => {
                elementStated.listener.removeListener(onEventUpdate)
            }
        }
    }, [elementStated]) // eslint-disable-line react-hooks/exhaustive-deps

    return event
}

export function useBowtieStateds(elementStated: Stated[]): ChartEvent[] {
    const [event, setEvent] = useState<ChartEvent[]>(elementStated?.map(es => es?.event) ?? [])

    useEffect(() => {
        if (elementStated) {
            elementStated.map(stated => stated.event)
            const onEventUpdate = (): void => {
                setEvent(elementStated.map(stated => stated.event))
            }

            elementStated.forEach(state => state.listener.registerListener(onEventUpdate))

            return () => {
                elementStated.forEach(state => state.listener.removeListener(onEventUpdate))
            }
        }
    }, [elementStated]) // eslint-disable-line react-hooks/exhaustive-deps

    return event
}
